<section id="atomo-super-app"
  class="flex flex-col items-center justify-center px-4 md:px-0 lg:px-0 py-10 md:pt-6 lg:pt-10 md:pb-0 lg:pb-0 max-w-7xl mx-auto">

  <p class="text-purple_100 text-hurrey-24 md:text-hurrey-28 lg:text-hurrey-36 mb-8 md:mb-12">THE PARTNERSHIP ECOSYSTEM
  </p>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 w-full">
    <div class="col-span-1 p-4 md:p-6 flex items-center justify-center bg-gray-50 rounded-lg md:bg-transparent">
      <img src="../../../../assets/images/ATOMO Original.webp" alt="ATOMO"
        class="h-24 md:h-32 lg:h-40 w-auto object-contain hover:scale-105 transition-transform duration-300">
    </div>

    <div class="col-span-1 flex flex-col gap-2 items-start justify-center md:pr-14 lg:pr-[108px]">
      <p class="text-purple_100 text-hurrey-28" id="atomo_hardware_as_a_service"> Atomo </p>
      <p class="text-hurrey-12 lg:text-hurrey-16 mb-3" id="atomo_hardware_as_a_service_description">
        <span class="text-black font-semibold">Technology Partner</span> <br>
        <span class="text-grey"> India's leading AI-powered education platform provides the technological
          backbone adaptive learning algorithms, interactive content delivery systems, and analytics dashboards that
          power every Digital Pathashala classroom.</span>
      </p>
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 w-full">
    <div
      class="col-span-1 flex flex-col order-last md:order-first gap-2 items-start justify-center md:pl-14 lg:pl-[108px]">
      <p class="text-purple_100 text-hurrey-28" id="atomo_software_as_a_software"> Build a Class Initiative</p>
      <p class="text-hurrey-12 mb-3 lg:text-hurrey-16" id="atomo_software_as_a_software_description">
        <span class="text-black font-semibold">Implementation Partner </span> <br>
        <span class="text-grey"> With expertise in grassroots educational interventions and over 1 million students
          reached, Build a Class Initiative manages on-ground implementation, teacher training, community engagement,
          and ongoing technical support across 100+ schools.</span>
      </p>
    </div>

    <div class="col-span-1 p-4 md:p-6 flex items-center justify-center bg-gray-50 rounded-lg md:bg-transparent">
      <img src="../../../../assets/images/build_a_class.webp" alt="Build a Class"
        class="h-24 md:h-32 lg:h-40 w-auto object-contain hover:scale-105 transition-transform duration-300">
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 w-full">
    <div class="col-span-1 p-4 md:p-6 flex items-center justify-center bg-gray-50 rounded-lg md:bg-transparent">
      <img src="../../../../assets/images/AMNS INDIA.webp" alt="AMNS"
        class="h-24 md:h-32 lg:h-40 w-auto object-contain hover:scale-105 transition-transform duration-300">
    </div>

    <div class="col-span-1 flex flex-col gap-2 items-start justify-center md:pr-14 lg:pr-[108px]">
      <p class="text-purple_100 text-hurrey-28" id="atomo_hardware_as_a_service"> AMNS India </p>
      <p class="text-hurrey-12 lg:text-hurrey-16 mb-3" id="atomo_hardware_as_a_service_description">
        <span class="text-black font-semibold">CSR Funder</span> <br>
        <span class="text-grey"> ArcelorMittal Nippon Steel India funds and champions Digital Pathashala as part of its
          comprehensive educational portfolio, demonstrating how corporate resources can drive measurable social
          impact.</span>
      </p>
    </div>
  </div>

</section>